import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputRef", "isRequired", "readOnly", "onOpenChange"];
import { memo } from 'react';
import InternalValueTooltip from './externalOptions/InternalValueTooltip';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import TaxCategorySelect from './taxCategory/TaxCategorySelect';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useProperty } from '../v2/hooks/useProperty';
import { useInternalPropertyValue } from '../v2/hooks/useInternalPropertyValue';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputTaxCategory = _ref => {
  let {
      inputRef,
      isRequired,
      readOnly,
      onOpenChange
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  useComponentMountMetric('PropertyInputTaxCategory');
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const internalValue = useInternalPropertyValue();
  const value = usePropertyValue();
  const select = /*#__PURE__*/_jsx(TaxCategorySelect, Object.assign({}, getTransferrableProps(props), {
    value: value,
    clearable: !isRequired,
    minimumSearchCount: 0,
    inputRef: inputRef,
    readOnly: readOnly,
    onOpenChange: onOpenChange
  }));
  if (readOnly) {
    return /*#__PURE__*/_jsx(InternalValueTooltip, {
      internalValue: internalValue,
      objectTypeId: objectTypeId,
      property: property,
      children: select
    });
  }
  return select;
};
export default /*#__PURE__*/memo(PropertyInputTaxCategory);